import React, { useEffect, useState } from "react";
import parse, { domToReact } from "html-react-parser";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import LogoContainer from "../common/LogoContainer";

const PrivacyNoticeDialog = (props: any) => {
    const [state, setState] = useState({ isLoading: true, content: "" });
    const ModuleCustomSettingsIds = { PrivacyPolicy: 1350, CanadianPrivacyPolicy: 12374 };
    let authData = useSelector((state: ApplicationState) => {
        if (state.creditAuthData.authData != null) {
            return {
                isIDFUser: state.creditAuthData.authData.isIDFUser,
                partnerId: state.loggedInUser?.userInfo?.partnerID,
                status: state.creditAuthData.authData["status-code"],
            };
        }
        return { isIDFUser: "", partnerId: 36, status: "" };
    });
    const isCignaPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
        state.configurationState.configuration.partnerConfig.partnerId &&
        state.configurationState.configuration.partnerConfig.partnerId === 2559
            ? true
            : false
    );
    const showLogoOnRegistrationScreens: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.includePartnerLogo
            : false
    );
    let partnerData = useSelector((state: ApplicationState) => {
        if (state.configurationState?.configuration?.partnerConfig != null) {
            let { email, partnerId, phoneNumber } = state.configurationState.configuration.partnerConfig;
            return {
                email: email,
                phoneNumber: phoneNumber,
                partnerId: partnerId,
            };
        }
        return {
            email: "",
            phoneNumber: "",
            partnerId: 36,
        };
    });

    const printDiv = () => {
        let content: any = document.getElementById("printPP");
        let printDoc: any = window.open("", "Print-Window");
        if (printDoc) {
            printDoc.document.open();
            printDoc.document.write('<html><body onload="window.print()">' + content.innerHTML + "</body></html>");
            printDoc.document.close();
            setTimeout(() => {
                printDoc.close();
            }, 10);
        }
    };

    const options = {
        replace: ({ attribs, children }: any) => {
            if (!attribs) return;

            if (attribs.hasOwnProperty("class")) {
                if (attribs.class.indexOf("pdfPrint_icons") !== -1) {
                    return (
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                printDiv();
                            }}
                        >
                            <i className="las la-print" style={{ fontSize: "32px", float: "right" }}></i>
                        </a>
                    );
                }
            }

            if (attribs.hasOwnProperty("href")) {
                if (attribs.href.indexOf("#thirdparty-collecting-info") !== -1) {
                    return (
                        <a
                            href="javascript:void(0);"
                            onClick={() => {
                                let element = document.querySelector(`a[name='thirdparty-collecting-info']`);
                                if (element) {
                                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                                }
                            }}
                        >
                            {domToReact(children, options)}
                        </a>
                    );
                }

                if (attribs.href.indexOf("#california") !== -1) {
                    return (
                        <a
                            href="javascript:void(0);"
                            onClick={() => {
                                let element = document.querySelector(`a[name='california']`);
                                if (element) {
                                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                                }
                            }}
                        >
                            {domToReact(children, options)}
                        </a>
                    );
                }

                if (attribs.href.indexOf("#") !== -1) {
                    return <a href="javascript:window.print();">{domToReact(children, options)}</a>;
                }
                if (attribs.href.indexOf("window.print()") !== -1) {
                    return <a href="javascript:window.print();">{domToReact(children, options)}</a>;
                }

                if (attribs.href.indexOf("javascript:void(0);") !== -1) {
                    const initialOnClickText = "(window.location.href=(window.location.href).split('#')[0]+'#";
                    if (attribs.hasOwnProperty("onclick") && attribs.onclick.startsWith(initialOnClickText)) {
                        let focusItemName: string = attribs.onclick;
                        focusItemName = focusItemName.replace(initialOnClickText, "");
                        focusItemName = focusItemName.replace(")", "");
                        focusItemName = focusItemName.replace("'", "");
                        return (
                            <a
                                href="javascript:void(0);"
                                onClick={() => {
                                    if (focusItemName) {
                                        let element = document.querySelector(`a[name='${focusItemName}']`);
                                        if (element) {
                                            element.scrollIntoView({ behavior: "smooth", block: "start" });
                                        }
                                    }
                                }}
                            >
                                {domToReact(children, options)}
                            </a>
                        );
                    }
                    return <a href="javascript:void(0);">{domToReact(children, options)}</a>;
                }

                if (attribs.href.indexOf("info@ezshield.com") !== -1 && partnerData.email) {
                    return (
                        <a href={`mailto:${partnerData.email}`} target="_blank">
                            {partnerData.email}
                        </a>
                    );
                }

                if (attribs.href.indexOf("CommonDefinitions") !== -1 && authData.isIDFUser === false)
                    return (
                        <a href="/common-definition" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (
                    attribs.href.indexOf("TermsAndConditions") !== -1 ||
                    attribs.href.indexOf("terms-of-use") !== -1 ||
                    attribs.href.indexOf("canadian-terms-use") !== -1
                )
                    return (
                        <a href="/terms" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (
                    attribs.href.indexOf("EU-USPrivacyShield") !== -1 ||
                    attribs.href.indexOf("EUUSPrivacyShield") !== -1 ||
                    attribs.href.indexOf("privacy-shield-policy") !== -1
                )
                    return (
                        <a href="/privacy-shield" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("EUGDPRNotice") !== -1 || attribs.href.indexOf("eu-gdpr-fair-processing-notice") !== -1)
                    return (
                        <a href="/gdpr" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("ccpa-addendum") !== -1 || attribs.href.indexOf("CCPAAddendum") !== -1)
                    return (
                        <a href="/ccpa" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("https://aim.yahoo.com/aim/us/en/optout/") !== -1) {
                    return (
                        <a href="https://www.verizon.com/about/privacy/" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );
                }

                if (attribs.href.indexOf(window.location.hostname) === -1)
                    return (
                        <a href={attribs.href} target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );
            }
            if (attribs.name === "phone_number" && partnerData.phoneNumber) {
                return (
                    <a href={"tel:" + partnerData.phoneNumber}>
                        <span>{partnerData.phoneNumber}</span>
                    </a>
                );
            }
        },
    };

    const callAPI = (url: string, data: any): Promise<any> => {
        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ModuleCustomSettingsId: data.ModuleCustomSettingsId,
            },
            body: JSON.stringify(data),
        });
    };

    const isCanadianUser = (partnerId: any) => {
        const url = "api/CheckPartnerCountry/CheckPartnerCountry";
        const data: any = {};
        return callAPI(url, data).then((res: any): any => res.json());
    };

    const getPartnerCustomHtml = (data: any) => {
        const url = "api/GetPartnerCustomHtml/GetPartnerCustomHtml";
        callAPI(url, data)
            .then((res: any): any => res.json())
            .then((res: any): any => {
                if (res["hasError"] === false && res["legalDocuments"].length) {
                    setState({
                        isLoading: false,
                        content: res["legalDocuments"][0].value,
                    });
                }
            })
            .catch((error: Error): any => console.log(error));
    };

    useEffect(() => {
        let data: any = {
            ModuleCustomSettingsId: ModuleCustomSettingsIds.PrivacyPolicy,
        };
        if (authData.isIDFUser) {
            isCanadianUser(authData.partnerId)
                .then((res: any): any => {
                    if (res.isCanadianPartner) {
                        data = {
                            ModuleCustomSettingsId: ModuleCustomSettingsIds.CanadianPrivacyPolicy,
                        };
                    }
                    getPartnerCustomHtml(data);
                })
                .catch((error: Error): any => console.log(error));
        } else {
            getPartnerCustomHtml(data);
        }
    }, [setState]);

    return (
        <React.Fragment>
            <div className="dialog-body">
                {showLogoOnRegistrationScreens && (
                    <div className="col-xs-12 col-sm-0 text-align-center">
                        <LogoContainer internalPage={false} showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                    </div>
                )}
                <div className="dialog-billing-info large-dialog-scroll">
                    <div className="row" id="content">
                        <div className="col-xs">
                            {state.isLoading ? (
                                <div className="box-content loading"></div>
                            ) : (
                                <div className="box-content">
                                    {!isCignaPartner && authData.isIDFUser && <h2>Privacy Notice</h2>}
                                    {!isCignaPartner && !!authData && authData.status !== "200" && <h2 className="padding-bottom-s">Privacy Notice</h2>}
                                    {parse(state.content, options)}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PrivacyNoticeDialog;
